enum SurveyFormType {
  Beneficiary = "beneficiary",
  Partner = "partner",
  Beneficiary_demo = "beneficiary_demo"
}

export default SurveyFormType
